/**
 * Mounts the Marker.io feedback widget for allowlisted UAT testers.
 *
 * Renders nothing — the widget is a floating button injected by the Marker SDK.
 * Reads the current authed user and passes identity + tenant metadata so every
 * ticket arrives pre-tagged. Signing out unloads the widget (not just hides
 * it); a different account's sign-in gets a fresh one (see ``lib/marker``).
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { loadMarkerWidget, unloadMarkerWidget } from '@/lib/marker';

const MarkerWidget: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      void unloadMarkerWidget();
      return;
    }

    loadMarkerWidget(
      { email: user.email, fullName: user.display_name || user.email },
      {
        tenant_id: user.tenant_id,
        tenant_slug: user.tenant_slug,
        user_id: user.user_id,
        role: user.role,
        route: location.pathname,
      },
    );
  }, [isAuthenticated, user, location.pathname]);

  return null;
};

export default MarkerWidget;
